/*
 * Project: BookingEngine
 * Module: components/booking/confirmation/Checkbox.js
 * vim:ft=javascript.jsx:
 */
import React from 'react';
import PropTypes from 'prop-types';

import CheckboxIcon from '../icons/CheckboxIcon';

// import '../../static/less/global/forms.less';

const Checkbox = ({
  id, name, label, errorMsg, checked, disabled, onChange, width, height, color,
}) => (
  <div className={`Checkbox${checked ? ' checked' : ''}`}>
    <input id={id} type="checkbox" checked={checked} onChange={onChange} name={name} disabled={disabled} />
    <label htmlFor={id} className="check-label">
      <CheckboxIcon isChecked={checked} width={width} height={height} color={color}/>
      <span className="text">{label}</span>
    </label>
    {errorMsg ? <div className="error-message">{errorMsg}</div> : null}
  </div>
);

Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  label: PropTypes.node.isRequired,
  errorMsg: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string,
};

Checkbox.defaultProps = {
  checked: false,
  disabled: false,
  width: '20px',
  height: '20px',
  color: 'none',
};

export default Checkbox;
